import { render, staticRenderFns } from "./GeographicAreas.vue?vue&type=template&id=08b05fd7&scoped=true"
import script from "./GeographicAreas.vue?vue&type=script&lang=js"
export * from "./GeographicAreas.vue?vue&type=script&lang=js"
import style0 from "./GeographicAreas.vue?vue&type=style&index=0&id=08b05fd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b05fd7",
  null
  
)

export default component.exports